import { useTranslation } from 'react-i18next';

import { ColsControl } from './controls/cols-control';
import { BarcodeControl } from './controls/barcode-control';
import { QrControl } from './controls/qr-control';
import { SimpleControl } from './controls/simple-control';
import { Content, Item } from './controls.styled';

export const Controls = (props) => {
  const { cols, changeCols, minCols, maxCols, onChange } = props;
  const other = {
    onChange,
    maxCols,
  };
  const { t } = useTranslation();

  const items = [
    {
      title: 'Разделитель',
      content: '%separator%',
    },
    { title: 'Пустая строка', content: '%space%' },
    { title: 'Номер стойки', content: '%rack_number%' },
    { title: 'Номер билета', content: '%receipt_number%' },
    { title: 'Тариф', content: '%tariff%' },
    { title: 'Номер ГРЗ', content: '%vehicle_plate%' },
    { title: 'Дата и время выдачи', content: '%datetime%' },
  ];
  const itemsEl = items.map((el, idx) => (
    <Item key={idx}>
      <SimpleControl {...other} title={t('forms.' + el.title)} content={el.content} />
    </Item>
  ));

  return (
    <Content>
      <Item>
        <ColsControl value={cols} onChange={changeCols} minCols={minCols} maxCols={maxCols} />
      </Item>
      <Item>
        <BarcodeControl {...other} />
      </Item>
      <Item>
        <QrControl {...other} />
      </Item>
      {itemsEl}
    </Content>
  );
};
